import * as tslib_1 from "tslib";
import { Model } from '@app/models/model';
var Device = /** @class */ (function (_super) {
    tslib_1.__extends(Device, _super);
    function Device() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Device.prototype.calculateOverallStatus = function () {
        if (this.location) {
            if (this.location.status === 'Active' && !this.connected) {
                this.overallStatus = 'Offline';
            }
            else {
                this.overallStatus = this.location.status;
            }
        }
    };
    return Device;
}(Model));
export { Device };
